<template>
    <b-card class="col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-4  border-0 shadow p-4">
            <div class="d-flex align-items-baseline text-secondary">
                <span class="mr-2"><b-icon icon="info-circle" /></span>
                <div class="d-flex flex-column">
                    <span class="mr-2 ">На почту организации был выслан код подтверждения.</span>
                    <span class="mr-2 ">Код из письма действителен в течение 10 минут.</span>
                </div>
            </div>

            <b-form @submit.stop.prevent="onSubmit" class="mt-5">

                <transition name="fade" mode="out-in">
                    <div class="d-flex flex-column mb-3" v-if="failMessages.length">
                        <span class="text-danger" v-for="(failMessage, i) in failMessages">{{ failMessage }}</span>
                    </div>
                </transition>


                <b-form-group class="mb-4"
                    id="code-group"
                    label="Код подтверждения"
                    label-for="username">
                    <b-form-input
                        id="username"
                        v-model="validCode"
                        type="text"
                        :state="validateState('code')"
                        aria-describedby="code-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="code-live-feedback">{{ validationMessageText($v.form.code) }}</b-form-invalid-feedback>
                </b-form-group>
                <b-button type="submit" variant="primary" :disabled="$v.$anyError" class="mr-3 mb-3">Отправить</b-button>
                <b-button type="button" variant="secondary" class="mb-3" @click="backToLogin">Вернуться к форме входа</b-button>
            </b-form>
    </b-card>

</template>

<script>
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import {validationMessage} from "vuelidate-messages";
import {formMessages} from "@/utils/validationMessages";
import {mapGetters} from "vuex";
import httpClient from "@/http";
import AuthConstants from "@/store/auth/constants";

export default {
    name: "LoginConfirmationForm",
    mixins: [validationMixin],
    data() {
        return {
            form: {
                code: null
            },
            errors: {
                code: [],
            },
            failMessages: []
        }
    },
    validations: {
        form: {
            code: { required },
        }
    },
    computed: {
        ...mapGetters(['authenticatedUserId']),
        validCode: {
            get: function () {
                return this.$v.form.code.$model
            },
            set(value) {
                if (value) {
                    value = value.replace(/\D+/g, '');
                }
                this.$v.form.code.$model = value
            }
        }
    },
    methods: {
        validateState(name) {
            const {$dirty, $error} = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        validationMessageText: validationMessage(formMessages, {dirty: true, first: 1}),
        onSubmit() {
            this.confirm();
        },
        reset() {
            this.errors.code = [];
            this.$emit('form-error-reset');
        },
        backToLogin() {
            this.$router.push({name: 'login'});
        },
        confirm() {
            const vm = this;
            const url = '/accounts/login/confirm/';
            const data = {
                'code':  this.form.code,
                'user_id': this.authenticatedUserId
            }
            httpClient.post(url, data)
                .then(response => {
                    vm.$store.dispatch(AuthConstants.AuthActions.AUTH_UPDATE_USER, {user: response.data['user']})
                }).then(() => {
                    vm.$router.push('/');
                })
                .catch(reason => {
                    if (reason.response !== undefined && reason.response.data !== undefined) {
                        const data = reason.response.data;
                        if (data['detail']) {
                            vm.failMessages = [data['detail']];
                        }
                        if (vm.failMessages.length) {
                            vm.$emit('form-error-received');
                        }
                        vm.validCode = null;
                    }
                })
        }
    }
}
</script>

<style scoped>

</style>